import _ from 'lodash'

let visible = false
let disabled = true

// key -> permission
const clientPermissionRestriction = {
    editCreateRequest: {disabled},
    viewDefaultRequest: {visible},
    viewComplianceEstimationRequest: request =>
        request.isComplianceEstimation && !request.isEsPreExaminationService ? {disabled} : {},
    viewEsPreExamComplianceEstimationRequest: request =>
        request.isComplianceEstimation && request.isEsPreExaminationService ? {disabled} : {},
    viewConclusionRequestRequest: request =>
        request.isConclusionRequest ? {disabled} : {},
    editDefaultRequest: {disabled},
    //editRequestWithRemarks: (request) => !(request.remarks.requestFolder || request.remarks.requestItem) ? {disabled} : {},
    editRequestWithRemarks: (request) => (request.remarks && request.remarks.requestRemarks.length > 0)  ? {} : {disabled},
    editHasLinkedRequest: {disabled},
    viewMultiFileUpload: {visible},
    viewDocument: {visible},
    editDocument: {disabled},
    signDocument: {visible},
    viewPrintForm: {visible},
    signPrintForm: {disabled},
    viewContractDocuments: {visible},
    viewConclusionApplication: {visible},
    viewExistConclusionApplication: request => request.conclusionExists ? {} : {visible},
    viewRequestNavigation: {visible},
    viewDocumentNavigation: {disabled},
    interactFormNavigation: {disabled},
    viewFormNavigation: {visible},
    viewContractDocumentsNavigation: {disabled},
    viewConclusionApplicationNavigation: {disabled},
    viewExistConclusionApplicationNavigation: request => request.conclusionExists ? {} : {disabled},
    viewSaveButton: {visible},
    viewCorrectedTEPNavigation: {visible},
    interactCorrectedTEPNavigation: {disabled},
    hideCopyTechIndicators: {disabled},
    interactEditTEONavigation: {disabled},
    viewCorrectedTEP: {visible},
    editCorrectedTEP: {disabled},
    viewRemarksNavigation: {visible},
    viewRemarks: {visible},
    viewProjectProgressNavigation: {visible},
    viewProjectProgress: {visible},
    viewRequestText: {visible},
    viewPaperContractDocumentAlert: {visible},
    viewPaperActDocumentAlert: {visible},
    activeContractDocuments: {disabled},
    activeActDocuments: {disabled},
    activeDisputeProtocol: {disabled},
    viewConclusionDocuments: {visible},
    viewTextRemarks: {visible},
    viewSummaryRemarks: {visible},
    viewPrevContractDocuments: {visible},
    viewDocumentsPrintedFormNavigation: {visible},
    viewDocumentsPrintedForm: {visible},
    viewContractTerminationAgreementAlert: {visible},
    viewContractTerminationAgreement: {visible},
    activeContractTerminationAgreement: {disabled},
    activeContractTerminationForm: {disabled},
    viewDeadlineExtendForm: {visible},
    activeDeadlineExtendLetter: {visible},
    viewAlertWarningForSignContract: {visible},
    viewAlertWarningForSignContractAndSettlementProtocol: {visible},
    viewPaperContractDisputeDocumentAlert: {visible},
    activeExtensionAgreementDocuments: {disabled},
    viewPaperExtensionAgreementAlert: {visible},
    viewDisputeProtocolBtn: {visible},
    viewAdditionalAgreements: {visible},
    activeAdditionalAgreements: {disabled},
    viewLinkedRequestForm: {visible},
    editLinkedRequestForm: {disabled},
    interactLinkedRequestNavigation: {disabled},
    viewLinkedRequestNavigation: {visible},

// letter
// viewCustomLetter: {visibe},
// viewRequestChangedLetter: {visibe},
// viewCompletenessCorrectionEndedLetter: {visibe},
// viewContractDetailsChangedLetter: {visibe},
// viewContractTerminationLetter: {visibe},
// viewAdditionalAgreementLetter: {visibe},
// viewTEPChangedLetter: {visibe},
// viewExtensionAgreementDocument: {visibe},
// viewRemarksAnswersLetter: {visibe},
    viewSendLetterButton: {visible},

    actionCustomLetter: {disabled},
    actionRequestChangedLetter: {disabled},
    actionCompletenessCorrectionEndedLetter: {disabled},
    actionCompletionLetterEs: {disabled},
    actionContractDetailsChangedLetter: {disabled},
    actionContractTerminationLetter: {disabled},
    actionAdditionalAgreementLetter: {disabled},
    actionTEPChangedLetter: {disabled},
    actionExtensionAgreementLetter: request => request.beforeEndDate ? {disabled: false} : {disabled},
    actionRemarksAnswersLetter: {disabled},
    actionNameChangedNoticeLetter: {disabled},
    actionCostChangedNoticeLetter: {disabled},
    actionProlongationLetter: {disabled},
    viewDeleteRequestBtn: {visible},
    viewTerminateRequestButton: {visible},
    editMRA: request => request.hasOpenItemOrFolder ? {} : {disabled},
};

const serverPermissionRestriction = {
    GrantAccess: {visible},
    View: {visible},
    Edit: {disabled},
    Delete: {visible},
    Login: {visible},
    Administration: {visible},
    CreateUser: {visible},
    ListUsers: {visible},
    ListRequests: {visible},

    CreateRequest: {visible},
    ViewRequest: {visible},
    UpdateRequest: {disabled},
    DeleteRequest: {visible},
    CopyRequest: {visible},

    ChangeStateRequest: {visible},
    SigningDocumentation: {disabled},

    ViewOrganization: {visible},
    ListUnitedRequests: {visible},

    InitCompletness: {disabled},
    UploadDocumentation: {disabled},

    CreateParticipant: {visible},
    ListParticipant: {visible},
    ViewParticipant: {visible},
    UpdateParticipant: {disabled},
    DeleteParticipant: {visible},

    ViewDocumentation: {visible},
    ViewRemarksSection: {visible}
};

const wrongKeys = _.intersection(
    Object.keys(clientPermissionRestriction),
    Object.keys(serverPermissionRestriction)
);

if( wrongKeys.length !== 0 )
    throw `Client and server permission keys intersect: ${wrongKeys.join(',')}`

export {clientPermissionRestriction, serverPermissionRestriction}



// WEBPACK FOOTER //
// client/config/permissionRestriction.es6